export default __webpack_public_path__ + "static/media/Rectangle 56.19771bdb.png";